import { EventEmitter } from '@angular/core';
var ComponentTextarea = (function () {
    function ComponentTextarea() {
        this.outPutValue = new EventEmitter();
        this.wordCount = 0;
        this.exerciseScrollTop = 0;
    }
    ComponentTextarea.prototype.ngOnInit = function () {
        // this.wordCount = this.textareaValue ? this.textareaValue.length : 0;
        if (this.textareaValue) {
            this.calcTextareaLen(this.textareaValue);
        }
    };
    ComponentTextarea.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.type == 6 || this.type == 8) {
            setTimeout(function () {
                $('#component-textarea-' + _this.questionId + "-" + _this.id).height($('#component-textarea-' + _this.questionId + "-" + _this.id)[0].scrollHeight);
            });
        }
    };
    /**
     * 计算文本框字数
     * @param e: HTMLElement | String  文本框对象 | 文本内容
     */
    ComponentTextarea.prototype.calcTextareaLen = function (e) {
        if (this.wordCount >= this.maxLen && e.keyCode && e.keyCode == 8) {
            return;
        }
        else {
            // 取出回车字符
            var textareaVal = e.target ? ($(e.target).val().replace(/<(.+?)>/gi, "&lt;$1&gt;")).replace(/\n/gi, "|") : (e.replace(/<(.+?)>/gi, "&lt;$1&gt;")).replace(/\n/gi, "|");
            // 回车数量
            var entLen = textareaVal.split('|').length - 1;
            // 不包含回车的数量
            var strLen = textareaVal.split('|').join('').length;
            this.realMaxLen = this.maxLen + entLen;
            this.wordCount = strLen;
        }
    };
    // 文本框自适应高度
    ComponentTextarea.prototype.autoTextarea = function (e, type) {
        var _this = this;
        var exerciseItemWrap = document.getElementById("exercise-item-wrap-active");
        var textarea = document.getElementById("component-textarea-" + this.questionId + "-" + this.id);
        var pre = document.getElementById("fit1-" + this.questionId + "-" + this.id);
        pre.innerHTML = e.target.value;
        var realHeight = pre.offsetHeight; //offsetHeight = height + padding + border
        textarea.style.height = realHeight > 170 ? realHeight + 20 + 'px' : realHeight + 'px'; //加20为一行的高度
        var titlteHeight = document.querySelector(".question-title").clientHeight;
        //判断是ios还是安卓
        var userAgent = navigator.userAgent.toLowerCase();
        if (this.type == 1 || this.type == 7) {
            if (exerciseItemWrap) {
                setTimeout(function () {
                    var inpTop = realHeight + titlteHeight / 2 - 120;
                    var scrollTop = realHeight > 170 ? inpTop : titlteHeight > 320 ? titlteHeight / 2 : 80;
                    var androidTop = realHeight > 180 ? (_this.type == 7 ? realHeight + titlteHeight : realHeight + titlteHeight - 130) : (_this.type == 7 ? 200 : titlteHeight);
                    exerciseItemWrap.scrollTop = /android/i.test(userAgent) ? androidTop : scrollTop;
                }, 500);
            }
        }
        else if (this.type == 3 || this.type == 6 || this.type == 8) {
            setTimeout(function () {
                if (type == 'focus')
                    _this.exerciseScrollTop = Number(sessionStorage.getItem("exerciseScrollTop"));
                var answerStepWrap = document.getElementById("answer-step-wrap-" + _this.id);
                var scrollTop = _this.exerciseScrollTop + (answerStepWrap.offsetTop - _this.exerciseScrollTop) / 3;
                exerciseItemWrap.scrollTop = /android/i.test(userAgent) ? (realHeight > 180 ? answerStepWrap.offsetTop + 60 : answerStepWrap.offsetTop + 40) : (realHeight > 170 ? scrollTop + 40 : scrollTop);
            }, 500);
        }
        this.calcTextareaLen(e);
    };
    // 将内容传输到父组件
    ComponentTextarea.prototype.outPutTextareaVal = function (e) {
        this.autoTextarea(e, 'input');
        this.outPutValue.emit({
            'index': this.id,
            'questionId': this.questionId,
            'type': this.type,
            'content': $(e.target).val(),
            'wordOverrun': this.wordCount == this.maxLen
        });
    };
    return ComponentTextarea;
}());
export { ComponentTextarea };



// WEBPACK FOOTER //
// ./src/component/textarea/component.textarea.ts.pre-build-optimizer.js